<template>
  <div
    class="w-full bg-white rounded-lg shadow p-4 border border-gray-200 ml-5"
  >
    <div class="w-full flex flex-col justify-between">
      <h1 class="text-xl font-bold text-gray-700">Notificaciones</h1>
      <span class="text-sm text-gray-500">Recientes - 10 pendientes</span>
    </div>
    <div
      class="w-full pt-3 overflow-y-auto"
      :class="{ 'overflow-y-hidden': hideScroll, 'max-h-80': !hideScroll }"
    >
      <div v-if="$store.state.notifications.entities.length === 0">
        <div
          class="w-full h-40 flex flex-col justify-center items-center gap-2"
        >
          <i class="bx bx-bell-off text-4xl text-gray-300"></i>
          <span class="text-gray-400">No tienes notificaciones</span>
        </div>
      </div>
      <div
        v-for="notification in $store.state.notifications.entities.slice(0, 10)"
        :key="notification.id"
        class="w-full pt-3"
      >
        <div
          class="text-md"
          :class="{
            'cursor-pointer hover:text-purple-400': !notification.read,
          }"
        >
          <div
            class="w-full flex flex-row"
            :class="{ 'font-bold': !notification.read }"
          >
            <div class="w-full">
              <template>
                <div
                  @click="showNotification(notification)"
                  class="p-3 w-full bg-gray-50 cursor-pointer flex flex-row rounded-lg"
                >
                  <div
                    class="flex flex-row mt-1"
                    style="width: 30px; max-width: 30px"
                  >
                    <i
                      :class="notification.icon"
                      class="text-xl"
                      :style="{ color: notification.color }"
                    ></i>
                  </div>
                  <div class="flex flex-col justify-center gap-1">
                    <span>{{ notification.title }}</span>
                    <span class="text-sm text-gray-400">
                      {{ notification.description }}
                    </span>
                    <span class="text-sm text-gray-500 mr-2 font-bold">
                      Hace {{ notification.ago }}
                    </span>
                  </div>
                  <div class="flex flex-row items-center ml-auto">
                    <button
                      @click.stop="deleteNotification(notification)"
                      class="text-gray-400 hover:text-red-500 p-2"
                      title="Eliminar notificación"
                    >
                      <i class="bx bx-x"></i>
                    </button>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-row justify-center items-center mt-4">
      <button
        class="text-purple-400"
        @click="hideScroll = true"
        v-if="!hideScroll"
      >
        Ver todas
      </button>
      <button class="text-purple-400" @click="hideScroll = false" v-else>
        <i class="bx bx-arrow-up"></i> Ver menos
      </button>
    </div>
  </div>
</template>
<script>
import NotificationService from "@/services/NotificationService";
import { NOTIFICATIONS_MARK_AS_READ } from "@/store/modules/notifications/mutation-types";
import { NotificationTypeEnum } from "@/constants";
import error from "@/mixins/error";

export default {
  name: "Notifications",
  mixins: [error],
  data() {
    return {
      selection: [],
      hideScroll: false,
    };
  },
  methods: {
    async markAsRead(notificationId) {
      await NotificationService.markAsRead(notificationId);
      await this.$store.dispatch(NOTIFICATIONS_MARK_AS_READ, notificationId);
    },
    async showNotification(notification) {
      if (notification.entity) {
        switch (notification.entity.type) {
          case NotificationTypeEnum.Order:
            if (!notification.read) await this.markAsRead(notification.id);
            await this.$router.push({
              name: "orders.read",
              params: { id: notification.entity.id },
            });
            break;
          case NotificationTypeEnum.Product:
            if (!notification.read) await this.markAsRead(notification.id);
            await this.$router.push({
              name: "products.read",
              params: { id: notification.entity.id },
            });
            break;
          case NotificationTypeEnum.Expense:
            if (!notification.read) await this.markAsRead(notification.id);
            await this.$router.push({
              name: "expenses.index",
              params: { id: notification.entity.id },
            });
            break;
          default:
        }
      } else {
        this.$swal(notification.title, notification.description, "info").then(
          async (result) => {
            if (result.isConfirmed && !notification.read)
              await this.markAsRead(notification.id);
          }
        );
      }
    },
    async deleteNotifications() {
      if (this.selection.length) {
        this.$confirm(
          this.selection.length === 1
            ? `¿Está seguro que desea eliminar esta notificación?`
            : `¿Está seguro que desea eliminar estas notificaciones?`,
          {
            type: "warning",
            confirmButtonText: "OK",
            cancelButtonText: "Cancelar",
          }
        ).then(async () => {
          try {
            await NotificationService.delete(this.selection);
            this.$toastr.s(
              this.selection.length === 1
                ? "La notificación se eliminó correctamente"
                : "Las notificaciones se eliminaron correctamente"
            );
              this.selection = [];
              // refrescar notificaciones
              await NotificationService.get();
          } catch (error) {
            this.$toastr.e(this.getErrorMessage(error));
          }
        });
      }
    },
    async deleteNotification(notification) {
      try {
        await NotificationService.delete([notification.id]);
        this.$toastr.s("La notificación se eliminó correctamente");
        // refrescar notificaciones
        await NotificationService.get();
      } catch (err) {
        this.$toastr.e(this.getErrorMessage(err));
      }
    },
  },
};
</script>
